import groq from 'groq';
import { ComponentType } from '$lib/sanity/types';
import { TextComponentFragment } from './text';

export const IconStackComponentFragment = groq`
  ...,
  ${TextComponentFragment},
  icon->
`;

export const GetIconStackQuery = groq`
  *[_type == "${ComponentType.IconStack}" && _id == $id]{
    ${IconStackComponentFragment}
  }[0]
`;
